/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "下载Bumble",
      "全部接受",
      "管理选项",
      "Cookie政策",
      "返回",
      "手机号码不正确",
      "© {{current_year}} Bumble | 保留所有权利",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "关于",
      "大使",
      "嗡嗡",
      "我们使用cookies。保留当前设置表示您同意这一点。",
      "下载应用",
      "Android下载",
      "iOS下载",
      "对不起，无法找到该网页。",
      "登录",
      "加入",
      "一起加入吧！",
      "啊，发生了一个错误"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小时"
            ],
            "singular": [
                  "小时"
            ]
      },
      "minute": {
            "plural": [
                  "分钟"
            ],
            "singular": [
                  "分钟"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
